import axios from 'axios';
import {useEffect, useState} from 'react';
import {environment} from '@shared/config/environment';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {Stack} from '@mui/material';

async function getToken(setIsLoading: any) {
  const {supersetConfig} = environment;
  // calling login to get access token
  if (!supersetConfig) {
    return null;
  } else {
    setIsLoading(true);
  }

  const {login_body, login_headers, supersetUrl} = supersetConfig;

  const supersetApiUrl = supersetUrl + '/api/v1/security';

  const {data} = await axios.post(
    supersetApiUrl + '/login',
    login_body,
    login_headers
  );
  const access_token = data['access_token'];

  const superset_url =
    supersetUrl +
    '/login/?username=' +
    login_body?.username +
    '&token=' +
    access_token;

  const iframe = document.querySelector('iframe');
  if (iframe) {
    iframe.src = superset_url;
    iframe.style.width = '99%'; // Set the width as needed
    iframe.style.minHeight = '92vh'; // Set the height as needed
    setIsLoading(false)
  }
}

const SupersetComponent = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    getToken(setIsLoading);
  }, []);

  return (
    <div style={{overflowX: 'hidden', maxHeight: '93vh'}}>
      {isLoading ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <LoadingScreen />
        </Stack>
      ) : (
        <></>
      )}
      <iframe style={{display:`${isLoading ? 'none': 'block'}`}} frameBorder="0"></iframe>
    </div>
  );
};

export default SupersetComponent;

